import * as React from 'react';

import { Tag } from '../../common/components/tag';
import * as styles from './CommercialOwnerTag.css';
import { getCommercialOwnerTagTitle } from './internal/utils/getCommercialOwnerTagTitle';
import { ICommercialOwnerTagProps } from './types';

export const CommercialOwnerTag: React.FC<ICommercialOwnerTagProps> = props => {
  const { type } = props;

  return <Tag className={styles['tag']}>{getCommercialOwnerTagTitle(type)}</Tag>;
};

CommercialOwnerTag.displayName = 'CommercialOwnerTag';
